<template>
  <div class="content">
    <iframe
      scrolling="no"
      width="100%"
      style="border: none; height: 1100px"
      :src="urlForm"
      title="integração" />
  </div>
</template>

<script>
  export default {
    name: "Formulario",
    data () {
      return {
        urlForm: process.env.VUE_APP_FORM_INTEGRATION_ONRCPN_URL
      }
    }
  }
</script>
